import { useState, useLayoutEffect } from 'react';

export default function useWindowSize() {
    const [size, setSize] = useState(() => {
        // Initialize with actual window size to prevent initial update
        if (typeof window !== 'undefined') {
            return [window.innerWidth, window.innerHeight];
        }
        return [0, 0];
    });
    
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        // Don't call updateSize() here since we already have the initial size
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}
